import React, { useState } from "react";
import { Button, Dropdown, Header, Modal } from "semantic-ui-react";
import SequenceForm from "./SequenceForm";

export default function SequenceModal(props) {
  const [modalOpen, setModalOpen] = useState(false);

  const handleOpen = () => setModalOpen(true);

  const handleClose = () => setModalOpen(false);

  const onSuccess = async => {
    handleClose();
    props.onSuccess();
  };

  return (
    <Modal
      open={modalOpen}
      onClose={handleClose}
      closeOnDimmerClick={false}
      size="small"
      closeIcon
      onFocus={e => e.stopPropagation()}
      onClick={e => e.stopPropagation()}
      trigger={
        props.button ? (
          <Button
            content="New Sequence"
            onClick={handleOpen}
            size="tiny"
            className="item-adder"
          />
        ) : (
          <Dropdown.Item
            className="primary"
            content={props.sequenceId ? "Edit Sequence" : "New Sequence"}
            icon={props.sequenceId ? "edit" : null}
            onClick={handleOpen}
          />
        )
      }
    >
      <Header content={props.sequenceId ? "Edit Sequence" : "New Sequence"} />
      <Modal.Content>
        <SequenceForm onSuccess={onSuccess} sequenceId={props.sequenceId} />
      </Modal.Content>
    </Modal>
  );
}
